import { render, staticRenderFns } from "./callReason.vue?vue&type=template&id=4f48575e&"
import script from "./callReason.vue?vue&type=script&lang=js&"
export * from "./callReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports